const PHONE_PATH = '/app/agent-phone';

export function getAgentPhonePath(): string {
  return PHONE_PATH;
}
